import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useToasts } from 'react-toast-notifications';
import moment from 'moment';
import CloseButton from './CloseButton';
import { useDispatch } from 'react-redux';
import { setAlert } from '../../redux/actions';
import { Spinner } from 'react-bootstrap';

const PUnfollow = ({
    show, setShow, activeFollowing, handleStatus,
}) => {
    const { addToast } = useToasts();

    const dispatch = useDispatch();

    const [busy, setBusy] = useState(false);

    const handleClose = () => {
        setShow(false);
        setBusy(false);
    };

    const formik = useFormik({
        initialValues: {
            unfollow_reason: '',
        },
        validationSchema: Yup.object({
            unfollow_reason: Yup.string().required('Please select a reason for unsubscribing'),
        }),
        onSubmit: async (values, { setErrors }) => {
            setBusy(true);
            await axios.patch(`/api/followings/${activeFollowing.id}`, {
                user_id: activeFollowing.pu,
                action: 'unfollow',
                ...values,
            }).then((response) => {
                handleStatus(true);
                setShow(false);
                setBusy(false);
                // addToast(`${activeFollowing.following_information.login} successfully unfollowed`, { appearance: 'success', autoDismiss: true });
                dispatch(setAlert({
                    type: 'error',
                    show: true,
                    body: `${activeFollowing.following_information.login} successfully unfollowed`
                }));
            }).catch((error) => {
                handleStatus(false);
                setBusy(false);

                let payload = {
                    type: 'error',
                    show: true
                };

                if (error.response && error.response.status === 409) {
                    payload.body = error.response.data.error;
                } else {
                    payload.body = 'Unable to process request';
                }

                dispatch(setAlert(payload));
            });
        },
    });

    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            className="unfollowModal"
            centered
        >
            <form onSubmit={formik.handleSubmit}>
                <Modal.Header
                    style={{
                        borderBottom: 0
                    }}
                >
                    <CloseButton
                        onClick={handleClose}
                        style={{
                            position: 'absolute',
                            top: '12px',
                            right: '12px'
                        }}
                        disabled={busy}
                    />
                </Modal.Header>
                <Modal.Body>
                    <h5 style={{ fontSize: 18 }}>
                        Do you want to cancel your subscription to
                        {' '}
                        {' '}
                        <span className="span_puname">{activeFollowing.following_information.login}</span>
                        ?
                    </h5>
                    <p>
                        <span className="span_puname">{activeFollowing.following_information.login}</span>
                        {' '}
                        will lose your valuable support and you will lose your Subscription benefits at the end of your current subscription period on
                        {' '}
                        <span id="span_subsdate">
                            {moment(moment.utc(activeFollowing.subscribed_at).local()).add(1, 'month').format('ll')}
                        </span>
                        .
                    </p>
                    <div className="form-group">
                        <label>Reason for cancellation:</label>
                        <select
                            id="unfollow_reason"
                            name="unfollow_reason"
                            className={`form-control${formik.errors.unfollow_reason && formik.touched.unfollow_reason ? ' is-invalid' : ''}`}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.unfollow_reason}
                            disabled={busy}
                        >
                            <option value="">Select Reason</option>
                            <option value="Insufficient posts">Insufficient posts</option>
                            <option value="Does not reply to messages">Does not reply to messages</option>
                            <option value="Price too high">Price too high</option>
                            <option value="Quality of content">Quality of content</option>
                            <option value="May re-subscribe in the future">May re-subscribe in the future</option>
                            <option value="Other">Other</option>
                        </select>
                        {formik.errors.unfollow_reason && formik.touched.unfollow_reason ? <div className="invalid-feedback">{formik.errors.unfollow_reason}</div> : null}
                    </div>
                    {
                        busy && <React.Fragment>
                            <div className="alert alert-info mt-3 p-2 text-center">
                                <Spinner variant="primary" size="sm" animation='border' /> Please wait a moment while the unfollow is processed
                            </div>
                        </React.Fragment>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="light"
                        onClick={handleClose}
                        disabled={busy}
                    >
                        Cancel
                    </Button>
                    <Button type="submit" variant="primary" disabled={busy}>
                        {busy ? 'Processing...' : 'Confirm'}
                    </Button>
                </Modal.Footer>
            </form>
        </Modal>
    );
};

export default PUnfollow;
